import { Twitter, Discord } from '../utils/fa';

export const Socials = props => {
    return (
      <div id="socials">
        <a href="https://twitter.com/Squish_a_Plush" target="_blank"><Twitter/></a>{" "}
        <a href="#"><Discord/></a>
      </div>
    )
  }